import React from 'react'
import Banner from './Banner'
import SamsaMandate from './SamsaMandate'
import Services from './Services'
import LatestMarineInfo from './LatestMarineInfo'
import ServiceSlider from '../ServicesPage/ServiceSlider'

function HomePage() {

  return (
    <>
    <Banner />

    <SamsaMandate />

    <div className='new_bg_style'>
      <section className="latest-marine-info px-3 pb-0" id="latest-marine-info">
        <div className="container max-1330">
          <div className='text-center mb-4 mb-md-5'>
              <h1 className="section-title">Services</h1>
              <p className='d-none'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
          </div>
          
          <ServiceSlider/>
        </div>
      </section>
      <LatestMarineInfo/>
    </div>

 
    </>
  )
}

export default HomePage